/**
 * Wraps content that requires a specific feature. If the user's plan doesn't
 * include the feature, shows UpgradeOverlay instead. Use for premium routes.
 */

import React from 'react';
import { usePlan } from '../contexts/PlanContext';
import UpgradeOverlay from './UpgradeOverlay';

export default function RequireFeature({ featureKey, children }) {
  const { hasFeature, loading } = usePlan();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!hasFeature(featureKey)) {
    return <UpgradeOverlay featureKey={featureKey} />;
  }

  return children;
}
